import React from 'react';
import { Alert, Box, Typography } from '@mui/material';

/**
 * Honest placeholder for Settings areas without a backend yet (Phase 2.1).
 * No interactive controls — only an explanation.
 */
export default function SettingsComingSoon({ title, reason, children = null }) {
  return (
    <Box>
      <Typography variant="h5" sx={{ fontWeight: 600, mb: 2 }}>
        {title}
      </Typography>
      <Alert severity="info" sx={{ mb: children ? 2 : 0 }}>
        <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 0.5 }}>
          Coming soon
        </Typography>
        <Typography variant="body2" component="div">
          {reason}
        </Typography>
      </Alert>
      {children}
    </Box>
  );
}
